import React from 'react';
import { useEffect, useState , useRef} from "react";
import { Grid } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import start from "assets/images/Synchro/smart_display.svg";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Icon from "@mui/material/Icon";
import Tooltip from '@mui/material/Tooltip';
import MDSnackbar from "components/MDSnackbar";
import {decodeJwt } from "../../../authentication/authModules";
import config from "../../../config";

import axios from "axios";
import { useTranslation } from "react-i18next";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;
const BASE_URL = config.SYNCHROEU_URL.replace(/^https?:\/\//, '');

const CreateSumo = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("keycloak-token");
   var preferred_username ="";
   var xvfbScreen = "";
   var sumo_port = "";
  if (token) {
    try {
      //console.log("Token:", token);
      const tokenObject = decodeJwt(token);
      //console.log("Decoded Token:", tokenObject);
      preferred_username = tokenObject?.preferred_username || null; // Extract userId from token
      xvfbScreen = tokenObject?.xvfbScreen || null;
      sumo_port = tokenObject?.sumo_port || null;
    } catch (error) {
      console.error("Error decoding JWT:", error);
    }
  }

    const ITEM_HEIGHT = 70;
    const ITEM_PADDING_TOP = 2;
    const MenuProps = {
        PaperProps: {
            style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 300,
            },
        },
    };

    const names = [
    { key: 'baseline', value: t("sumo.scenarios.baseline") },
    { key: 'maxpressureacyclic', value: t("sumo.scenarios.acyclic") },
    { key: 'maxpressurenema', value: t("sumo.scenarios.nema") }
]
    
    const videoRef = useRef({});

    const [selectedStimulation, setSelectedStimulation] = useState(0);
    const [scenario, setScenario] = useState([]);
    const [live, setLive] = useState(false);
    const [executed, setExecuted] = useState(false);
    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const openSuccessSB = () => setSuccessSB(true);
    const closeSuccessSB = () => setSuccessSB(false);
    const openErrorSB = () => setErrorSB(true);
    const closeErrorSB = () => setErrorSB(false);
  
    const handleChange = (event) => {
      const {
        target: { value },
      } = event;
      console.log("Selected scenarios:", value);
      setScenario(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
      if(value.length > 1){
        setSelectedStimulation('all');
      }
    };
    const handlePickStimulation = (event) => {
        setSelectedStimulation(event.target.value);
    }
    const applyEnabled = () => {
        if(scenario.length > 1 || selectedStimulation === 'all'){
            return false;
        }
        return true;
    }

    useEffect(() => {
  if (!live) return;



}, [live]);
   
    function showLive(){

        //const ws = new WebSocket(`ws://160.40.63.72:${sumo_port}`);
        const ws = new WebSocket(`wss://${BASE_URL}/sumo/`);
        
        ws.binaryType = "arraybuffer";
        const mediaSource = new MediaSource();
        
        const videoElement = videoRef.current;
        videoElement.src = URL.createObjectURL(mediaSource);

        mediaSource.addEventListener("sourceopen", () => {
            const mimeCodec = 'video/webm; codecs="vp8"';
            if (!MediaSource.isTypeSupported(mimeCodec)) {
                console.error("Codec not supported:", mimeCodec);
                return;
            }

            const sourceBuffer = mediaSource.addSourceBuffer(mimeCodec);
            let queue = [];

            ws.onmessage = (event) => {
                if (sourceBuffer.updating || queue.length > 0) {
                    queue.push(event.data);
                } else {
                    sourceBuffer.appendBuffer(event.data);
                }
            };

            sourceBuffer.addEventListener("updateend", () => {
                if (queue.length > 0) {
                    sourceBuffer.appendBuffer(queue.shift());
                }
            });
            ws.onclose = () => {
                console.log("WebSocket connection closed");
                mediaSource.endOfStream();
            }
        });



    }

    const sumoStart = async () => {
        setExecuted(false);
        console.log("Start SUMO");
        const loweredScenarios = scenario.map(s => s.toLowerCase());
        const uniqueScenarios = new Set(loweredScenarios);
        const isSingleScenario = uniqueScenarios.size === 1;
        const guiAndXvfbValue = isSingleScenario ? live : false;
        const requestData = {
            user: preferred_username,
            project: "upper_cut",
            scenarios: names.filter(({ value }) => loweredScenarios.includes(value.toLowerCase())).map(({ key }) => key), // Convert "Baseline" to "baseline"
            all_scenarios: names.map(s => s.key.toLowerCase()), 
            useGui: guiAndXvfbValue,
            useXvfb: guiAndXvfbValue,
              simulationIndex: isSingleScenario 
            ? (selectedStimulation === 'all' ? 0 : Number(selectedStimulation)) 
            : -1,
            xvfbScreen: Number(xvfbScreen) || 0,
            width: 1024,
            height: 768,
            ffmpegFrames: 5,
            ffmpegBitrate: "500k",
            ffmpegBytes: 32768,
            create_plots: true,
            verbose: false,
          };

          console.log("Request Data:", JSON.stringify(requestData));

          try {
            var url =`${API_URL}/sumo`;
            console.log("url:", url);
            const response = await axios.post(url,requestData, {
              headers: {
                'X-API-Key': API_TOKEN,
                'Content-Type': 'application/json'
              }
            });
      
            if (response.status === 200) {
                setSuccessSB(true);
                setExecuted(true);
              
                if(live){
                    showLive();
                }
           
            } else {
                setExecuted(false);
                setErrorSB(true);
            }
          } catch (error) {
            console.log("SUMO started whith error:", error);    
            setExecuted(false);
            setErrorSB(true);
          } finally {
          
          }

     }

    function bringSuccessNotification(){
        return (
            <MDSnackbar
              color="success"
              icon="check"
              title={t("sumo.snackBar.successTitle")}
              content={t("sumo.snackBar.successContent")}
              dateTime={new Date().toLocaleTimeString()}
              open={successSB}
              onClose={closeSuccessSB}
              close={closeSuccessSB}
              bgWhite
            />
          );
    }

    function bringErrorNotification(){  
        return (
            <MDSnackbar
              color="error"
              icon="warning"
              title={t("sumo.snackBar.errorTitle")}
              content={t("sumo.snackBar.errorContent")}
              dateTime={new Date().toLocaleTimeString()}
              open={errorSB}
              onClose={closeErrorSB}
              close={closeErrorSB}
              bgWhite
            />
          );
    }


    return (

        <DashboardLayout>
            <MDBox mt={4} p={0}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                        <div className="notifications-container">
                            <div className="page-title" >{t("sumo.createTitle")}</div>
                            <div className="create-container">
                                <div className="startsumo-container">
                                    <div className="sumofilters">
                                        <FormControl sx={{ m: 1, width: 250 }}>
                                            <InputLabel id="sumo-scenario">{t("sumo.labels.selectScenario")}</InputLabel>

                                                <Select
                                                labelId="sumo-scenario"
                                                id="sumo-scenario"
                                                multiple
                                                value={scenario}
                                                onChange={handleChange}
                                                input={<OutlinedInput label={t("sumo.labels.selectScenario")} />}
                                                renderValue={(selected) => selected.join(', ')}
                                                MenuProps={MenuProps}
                                                style={{ paddingTop: '12px', paddingBottom: '12px', paddingRight: '7px' }}
                                            >
                                            {names.map(({ key, value }) => (
                                                <MenuItem key={key} value={value}>
                                                <Checkbox checked={scenario.includes(value)} />
                                                <ListItemText primary={value} />
                                                </MenuItem>
                                            ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl style={{ marginLeft: '10px', width: '140px'}}>
                                            <InputLabel id="select-stimulation">{t("sumo.labels.selectSimulation")}</InputLabel>
                                            <Select
                                                key={"stimulation"}  // Force re-render when value changes
                                                labelId="select-stimulation"
                                                id="select-stimulation"
                                                label={t("sumo.labels.selectSimulation")}
                                                value={selectedStimulation}
                                                onChange={handlePickStimulation}
                                                style={{ paddingTop: '12px', paddingBottom: '12px', paddingRight: '7px' }}
                                            >
                                                <MenuItem value={'0'}>0</MenuItem>
                                                <MenuItem value={'1'}>1</MenuItem>
                                                <MenuItem value={'2'}>2</MenuItem>
                                                <MenuItem value={'3'}>3</MenuItem>
                                                <MenuItem value={'4'}>4</MenuItem>
                                                <MenuItem value={'5'}>5</MenuItem>
                                                <MenuItem value={'6'}>6</MenuItem>
                                                <MenuItem value={'7'}>7</MenuItem>
                                                <MenuItem value={'8'}>8</MenuItem>
                                                <MenuItem value={'9'}>9</MenuItem>
                                                <MenuItem value={'all'}>{t("sumo.allOption")}</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {
                                            applyEnabled() 
                                            ?<FormControlLabel style={{width:"130px", marginLeft:'15px'}} control={<Checkbox checked={live} onClick={()=>{setLive(!live)}} />} label={t("sumo.labels.liveVideo")} />
                                            :<></>
                                        }
                                        <Tooltip title={t("sumo.liveUnavailable")} placement="top">
                                            <Icon fontSize="medium" style={{marginLeft:"15px"}}>info</Icon>
                                        </Tooltip>
                                    </div>
                                    <img src={start} alt="start" style={{ cursor: "pointer", width: "45px", marginRight:"15px" }} onClick={sumoStart}/>
                                    {successSB && bringSuccessNotification()}
                                    {errorSB && bringErrorNotification()}
                                </div>
                            </div>
                            {
                                (applyEnabled() && live ) && 
                                <div className="remote-display" >
                                        <div className="remote-display-title">{t("sumo.remoteDisplay.title")}</div>
                                    <div className='remote-display-body'>
                                        { videoRef && <video ref={videoRef} style={{width:"100%", height:"100%"}} controls autoPlay></video>}

                                    </div>
                                </div>
                            }

                        </div>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
};

export default CreateSumo;